import {useIsFocused} from '@react-navigation/native';
import {
  Alert,
  Button,
  ButtonBorder,
  Div,
  ImageView,
  InputItem,
  Label,
} from 'components';
import {Ecolors, Icons} from 'constant';
import I18n from 'languages/i18n';
import React, {useEffect, useRef, useState} from 'react';
import {ScrollView} from 'react-native';
import {loginWithPhone} from 'reducer/authen';
import {goBack, navigate} from 'services';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {checkLogin, isvalidPhone, widthScreen} from 'utils';
import {getStoreData, setStoreToken} from 'utils/storage';

function LoginScreen() {
  const dispatch = useAppDispatch();
  const isFocus = useIsFocused();
  const I18nState = useAppSelector(state => state.languages.I18nState);

  const isLoading = useAppSelector(state => state.authen.isLoading);
  const [isSaveName, setIsSaveName] = useState<boolean>(false);
  //
  const [isErrorPhone, setIsErrorPhone] = useState<boolean>(false);
  const [phone, setPhone] = useState('');
  const [phonePostal, setPhonePostal] = useState('VN(+84)');
  const phoneRef = useRef(null);
  const userRefCodeRef = useRef(null);

  interface ILblProps {
    content?: string;
    marginTop?: number;
  }

  function Lbl(props: ILblProps) {
    return (
      <Div
        flexDirection={'row'}
        alignItems={'center'}
        marginTop={props.marginTop ?? 0}
        justifyContent={'flex-start'}
        width={'100%'}>
        <Label>{props.content || ''}</Label>
        <Label multilanguage={false} color={Ecolors.red}>{` *`}</Label>
      </Div>
    );
  }

  useEffect(() => {
    if (isFocus) {
      setStoreToken('');
    }
    return () => {};
  }, [isFocus]);

  const onLogin = async () => {
    try {
      if (
        !checkLogin({
          phone: phone || '',
        })
      ) {
        return;
      }

      const obj: IParamsLogin = {
        phone: phone,
      };
      const res: any = await dispatch(loginWithPhone(obj)).unwrap();
      if (res?.data) {
        navigate('OtpRequestModal', {
          data: {
            requestOnSendOtp: res.data,
            flowApp: 'LoginWithPhone',
            phone: phone,
          },
        });
      } else {
        Alert.showError({
          content: `alert.dangnhapsai`,
        });
      }
    } catch (error: any) {
      Alert.showError({
        content: `alert.dangnhapsai`,
      });
    }
  };

  const gotoRegister = () => {
    navigate('RegisterScreen');
    return;
  };

  const gotoForgotPassword = () => {
    navigate('ForgotPasswordScreen');
  };

  const focusNextInput = (prefix: any) => {
    if (prefix) {
      prefix?.focus();
    }
  };
  const isHideBack = false;
  return (
    <Div>
      <Div
        style={{
          width: widthScreen,
        }}>
        <Div
          paddingLeft={19}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          paddingRight={24}>
          {isHideBack ? (
            <Div height={40} width={60} />
          ) : (
            <Button
              hitSlop={{top: 10, bottom: 10, left: 10, right: 10}}
              onPress={() => goBack()}
              height={40}
              width={60}
              paddingLeft={10}
              paddingVertical={10}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'flex-start'}>
              <ImageView
                source={Icons.back}
                width={8}
                height={14}
                resizeMode={'contain'}
                tintColor={Ecolors.textColor}
              />
            </Button>
          )}
        </Div>
        <ScrollView keyboardShouldPersistTaps={'handled'}>
          <Div style={{alignItems: 'center'}}>
            <Label
              multilanguage={false}
              style={{fontWeight: 'bold', fontSize: 34, flexDirection: 'row'}}>
              <Label
                style={{
                  fontWeight: 'bold',
                  fontSize: 34,
                  color: Ecolors.mainColor,
                }}
                multilanguage={false}>
                {'i'}
              </Label>
              {'TRUST'}
            </Label>
            <Label style={{marginTop: 10}} size={18} fontWeight="700">
              {`loginscreen.login`}
            </Label>
          </Div>
          {/* MARK: phone number
           */}
          <Div style={{paddingHorizontal: 20, marginTop: 30}}>
            <Lbl marginTop={13} content={`registerscreen.phonenumber`} />
            <Div
              marginTop={6}
              flexDirection={'row'}
              alignItems={'flex-start'}
              justifyContent={'space-between'}>
              <Div width={99}>
                <InputItem
                  placeholder={''}
                  isInput={false}
                  keyboardType={'name-phone-pad'}
                  marginHorizontal={0}
                  value={phonePostal}
                  onChangeText={setPhonePostal}
                />
              </Div>

              <Div style={{flex: 1, paddingLeft: 20}}>
                <InputItem
                  isError={isErrorPhone}
                  titleError={
                    phone.length > 0
                      ? `registerscreen.saisodienthoai`
                      : `registerscreen.sodienthoaikhongduocdetrong`
                  }
                  inputRef={phoneRef}
                  placeholder={I18n.t(`loginscreen.placeholderPhone`)}
                  keyboardType={'number-pad'}
                  marginHorizontal={0}
                  maxLength={20}
                  value={phone}
                  onChangeText={(t: string) => {
                    setPhone(t);
                    if (isErrorPhone) {
                      setIsErrorPhone(!isvalidPhone(t));
                    }
                  }}
                  onSubmitEditing={() => {
                    focusNextInput(userRefCodeRef.current);
                    setIsErrorPhone(!isvalidPhone(phone));
                  }}
                />
              </Div>
            </Div>
          </Div>

          {/* login button  */}
          <Div
            paddingTop={23}
            paddingHorizontal={20}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}>
            <ButtonBorder
              style={{flex: 1}}
              width={'100%'}
              loading={isLoading}
              title={`loginscreen.login`}
              onPress={onLogin}
            />
          </Div>
          <Div
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            paddingTop={20}
            paddingBottom={70}>
            <Div
              flexDirection={'row'}
              alignItems={'center'}
              width={'100%'}
              marginTop={11}
              justifyContent={'center'}
              flexWrap={'wrap'}>
              <Label>{`loginscreen.signuptitle`}</Label>
              <Button onPress={() => gotoRegister()}>
                <Label
                  fontWeight={'700'}
                  color={Ecolors.linkColor}>{`loginscreen.signup`}</Label>
              </Button>
            </Div>
            <Div height={100} />
          </Div>
        </ScrollView>
      </Div>
    </Div>
  );
}

export default React.memo(LoginScreen);
